import React from 'react';
import {render} from '../../src/utils/render';

export default () => {
  /*============================================================
                              click-button-alert
  ============================================================*/

  render('click-button-alert', () => {
    const handleClick = e => {
      alert('Clicked!');
    };

    const App = () => {
      return (
        <div>
          <button onClick={handleClick}>Click me!</button>
        </div>
      );
    };

    return <App />;
  });

  /*============================================================
                              SLIDE
  ============================================================*/

  render('modifying-variables', () => {
    let isActive = false;

    const handleClick = () => {
      isActive = !isActive;
      alert(isActive);
    };

    const App = () => {
      return (
        <div>
          <button style={{marginBottom: 10}} onClick={handleClick}>
            Toggle
          </button>
          <div className="text">{isActive ? 'On' : 'Off'}</div>
        </div>
      );
    };

    return <App />;
  });

  /*============================================================
                            SLIDE
============================================================*/

  render('first-stateful', () => {
    class App extends React.Component {
      state = {
        isActive: false
      };

      handleClick = () => {
        this.setState({
          isActive: !this.state.isActive
        });
      };

      render() {
        return (
          <div>
            <button style={{marginBottom: 15}} onClick={this.handleClick}>
              Toggle
            </button>
            <div className="text">{this.state.isActive ? 'On' : 'Off'}</div>
          </div>
        );
      }
    }

    return <App />;
  });

  /*============================================================
                            SLIDE
============================================================*/

  render('light-switch', () => {
    const LightSwitch = ({active}) => (
      <div className="text">Switch is {active ? 'on' : 'off'}</div>
    );

    class App extends React.Component {
      state = {
        isActive: false
      };

      handleToggle = () => {
        this.setState({isActive: !this.state.isActive});
      };

      render() {
        return (
          <div>
            <button onClick={this.handleToggle}> Toggle </button>
            <LightSwitch active={this.state.isActive} />
          </div>
        );
      }
    }

    return <App />;
  });

  /*============================================================
                            SLIDE
============================================================*/

  render('switch-interactive', () => {
    const LightSwitch = ({active, onToggle}) => (
      <button style={{margin: '15px 0'}} onClick={onToggle}>
        <span>Switch is {active ? 'on' : 'off'}</span>
      </button>
    );

    class App extends React.Component {
      state = {
        isActive: false
      };

      handleToggle = () => {
        this.setState({isActive: !this.state.isActive});
      };

      render() {
        return (
          <div>
            <LightSwitch
              active={this.state.isActive}
              onToggle={this.handleToggle}
            />

            <div className="text">{this.state.isActive ? 'On' : 'Off'}</div>

            <LightSwitch
              active={this.state.isActive}
              onToggle={this.handleToggle}
            />
          </div>
        );
      }
    }

    return <App />;
  });
};



// WEBPACK FOOTER //
// ./presentations/state-management/state-management.js